// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dropdown-item--search[data-v-25a6b22c]{position:sticky;background:#fff;top:0;z-index:10}", ""]);
// Exports
module.exports = exports;
